import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";
import { ArrowRight } from "lucide-react";
import { MaskedLines } from "@/components/Reveal";

export const CTAFinal = () => {
  const { t } = useLang();
  return (
    <section
      data-testid="cta-final"
      className="relative bg-[#1A1A1A] text-white py-32 md:py-40 overflow-hidden"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.85 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0 pointer-events-none"
      >
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full bg-[radial-gradient(closest-side,rgba(212,175,55,0.35),transparent_70%)]" />
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent opacity-50" />
      </motion.div>

      <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center">
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="overline mb-8 text-[#D4AF37]"
        >
          — Multident
        </motion.p>

        <h2 className="font-display font-extralight text-5xl md:text-7xl lg:text-[96px] leading-[1.02] tracking-tight">
          <MaskedLines
            lines={[
              t.cta_final.title,
              <span className="italic text-[#D4AF37]">
                {t.cta_final.title_accent}
              </span>,
            ]}
          />
        </h2>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.5 }}
          className="mt-8 text-white/70 text-base md:text-lg max-w-xl mx-auto"
        >
          {t.cta_final.sub}
        </motion.p>

        <motion.a
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.7 }}
          whileHover={{ scale: 1.03 }}
          data-testid="cta-final-btn"
          href="#contact"
          className="btn-premium mt-12 inline-flex items-center gap-3 bg-white text-[#1A1A1A] px-10 py-5 rounded-full text-base font-medium"
        >
          {t.cta_final.btn}
          <ArrowRight size={18} />
        </motion.a>
      </div>
    </section>
  );
};
